<mat-card class="login-card" [class.is-open]="cardOpen()">
	<mat-card-content>
		<form (ngSubmit)="loginSubmit()" [formGroup]="form">
			<mat-form-field appearance="fill">
				<mat-label>Adresse email</mat-label>
				<input
					autocomplete="email"
					formControlName="email"
					matInput
					type="email"
				>
			</mat-form-field>
			<mat-form-field appearance="fill">
				<mat-label>Mot de passe</mat-label>
				<input
					autocomplete="current-password"
					formControlName="password"
					matInput
					type="password"
				>
			</mat-form-field>
			@if (error()) {
				<mat-error class="error">Vos identifiants sont incorrects.</mat-error>
			}
			<mat-card-actions>
				<button
					[disabled]="!form.valid"
					mat-flat-button
				>
					@if (loading()) {
						<mat-spinner diameter="22"/>
					}
					Connexion
				</button>
			</mat-card-actions>
		</form>
	</mat-card-content>
</mat-card>
